export default __webpack_public_path__ + "static/media/2.07700c8c.jpg";